import { __, sprintf } from "@wordpress/i18n";
import {
  SelectControl,
  ToggleControl,
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from "@wordpress/components";
import { useToolsPanelDropdownMenuProps } from "../../utils";
import IconDisplay from "../../../../components/IconDisplay";
export default function Settings({ selectedWidth, attributes, setAttributes }) {
  const dropdownMenuProps = useToolsPanelDropdownMenuProps();

  return (
    <ToolsPanel
      label={__("Settings")}
      resetAll={() =>
        setAttributes({
          width: undefined,
          animation: "none",
          showText: true,
          icon: {
            enabled: false,
            name: "",
            type: "regular",
            position: "left",
            gap: "",
          },
        })
      }
      dropdownMenuProps={dropdownMenuProps}
    >
      <ToolsPanelItem
        label={__("Width")}
        isShownByDefault
        hasValue={() => !!selectedWidth}
        onDeselect={() => setAttributes({ width: undefined })}
        __nextHasNoMarginBottom
      >
        <ToggleGroupControl
          label={__("Width")}
          value={selectedWidth}
          onChange={(newWidth) => setAttributes({ width: newWidth })}
          isBlock
          __next40pxDefaultSize
          __nextHasNoMarginBottom
        >
          {[25, 50, 75, 100].map((widthValue) => {
            return (
              <ToggleGroupControlOption
                key={widthValue}
                value={widthValue}
                label={sprintf(
                  /* translators: %d: Percentage value. */
                  __("%d%%"),
                  widthValue
                )}
              />
            );
          })}
        </ToggleGroupControl>
      </ToolsPanelItem>
      <ToolsPanelItem
        label={__("Show Text")}
        isShownByDefault
        hasValue={() => attributes.showText !== true}
        onDeselect={() => setAttributes({ showText: true })}
        __nextHasNoMarginBottom
      >
        <ToggleControl
          label={__("Show Text")}
          checked={attributes.showText !== false}
          onChange={(value) => setAttributes({ showText: value })}
          help={__(
            "Toggle to show or hide the button text",
            "brandy-blocks"
          )}
          __nextHasNoMarginBottom
        />
      </ToolsPanelItem>
      <ToolsPanelItem
        label={__("Icon")}
        isShownByDefault
        hasValue={() => !!attributes.icon}
        onDeselect={() =>
          setAttributes({
            icon: {
              enabled: false,
              name: "",
              type: "regular",
              position: "left",
              gap: "",
            },
          })
        }
        __nextHasNoMarginBottom
      >
        <div className="brandy-icon-settings-component">
          <IconDisplay
            enabled={attributes.icon.enabled}
            name={attributes.icon.name}
            type={attributes.icon.type}
            position={attributes.showText ? attributes.icon.position : null}
            size={null}
            gap={attributes.showText ? attributes.icon.gap : null}
            handleChangeAttributes={(updates) =>
              setAttributes({ icon: { ...attributes.icon, ...updates } })
            }
          />
        </div>
      </ToolsPanelItem>
      <ToolsPanelItem
        label={__("Hover Animation")}
        isShownByDefault
        hasValue={() =>
          !!attributes.animation && attributes.animation !== "none"
        }
        onDeselect={() => setAttributes({ animation: "none" })}
        __nextHasNoMarginBottom
      >
        <SelectControl
          label={__("Hover Animation")}
          value={attributes.animation || "none"}
          onChange={(newAnimation) =>
            setAttributes({ animation: newAnimation })
          }
          help={__(
            "Choose a hover animation effect for your button",
            "brandy-blocks"
          )}
          __nextHasNoMarginBottom
          __next40pxDefaultSize={true}
        >
          <option value="none">{__("None", "brandy-blocks")}</option>
          <option value="swipe">{__("Swipe", "brandy-blocks")}</option>
          <option value="glow">{__("Glow", "brandy-blocks")}</option>
        </SelectControl>
      </ToolsPanelItem>
    </ToolsPanel>
  );
}
